module.exports = __webpack_public_path__ + "img/tuev-siegel.574e624.svg";